var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    attrs: {
      id: "sidebar-form-event-product",
      title: _vm.isEdit
        ? _vm.$t("Editar produto")
        : _vm.$t("Adicionar produto"),
      show: _vm.showSidebar,
      fetching: _vm.fetching,
      saving: _vm.saving,
      width: "600px",
    },
    on: { save: _vm.onSaveItem, hidden: _vm.hide },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "FormulateForm",
              { ref: "itemSidebarForm", attrs: { name: "itemSidebarForm" } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _vm.isEdit
                          ? _c("FormulateInput", {
                              attrs: {
                                id: "event_product_sidebar-sku_id",
                                type: "label",
                                label: _vm.$t("Produto"),
                              },
                              model: {
                                value: _vm.itemForm.sku.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.itemForm.sku, "name", $$v)
                                },
                                expression: "itemForm.sku.name",
                              },
                            })
                          : _c("e-search-sku", {
                              attrs: {
                                id: "event_product_sidebar-sku_id",
                                label: _vm.$t("Produto"),
                                "input-id": "event_product_sidebar-sku_product",
                                "value-is-object": "",
                                "store-id": _vm.storeId,
                                "price-table-id": _vm.priceTableId,
                                "default-options": _vm.defaultSkuOptions,
                                autofocus: "",
                              },
                              on: { input: _vm.onSelectProduct },
                              model: {
                                value: _vm.itemForm.sku,
                                callback: function ($$v) {
                                  _vm.$set(_vm.itemForm, "sku", $$v)
                                },
                                expression: "itemForm.sku",
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "5" } },
                      [
                        _vm.isEdit
                          ? _c("FormulateInput", {
                              attrs: {
                                id: "event_product_sidebar-quantity",
                                type: "label",
                                label: _vm.$t("Quantidade reservada"),
                                instruction: _vm.$t(
                                  "Quantidade a ser reservada para este produto no evento"
                                ),
                              },
                              model: {
                                value: _vm.itemForm.quantity,
                                callback: function ($$v) {
                                  _vm.$set(_vm.itemForm, "quantity", $$v)
                                },
                                expression: "itemForm.quantity",
                              },
                            })
                          : _c("FormulateInput", {
                              staticClass: "required",
                              attrs: {
                                id: "event_product_sidebar-quantity",
                                type: "text-number",
                                disabled: _vm.isEdit,
                                label: _vm.$t("Quantidade reservada"),
                                instruction: _vm.$t(
                                  "Quantidade a ser reservada para este produto no evento"
                                ),
                                validation: "required|min:1",
                              },
                              model: {
                                value: _vm.itemForm.quantity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.itemForm,
                                    "quantity",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "itemForm.quantity",
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.itemForm.id
                  ? _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "primary",
                                  disabled: _vm.maxQuantityToAdd === 0,
                                },
                                on: { click: _vm.addSkuStock },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Adicionar reserva de estoque"))
                                ),
                              ]
                            ),
                            _c(
                              "b-button",
                              {
                                staticClass: "ml-1",
                                attrs: {
                                  variant: "outline-primary",
                                  disabled: !_vm.itemForm.quantity,
                                },
                                on: { click: _vm.removeSkuStock },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Remover reserva de estoque"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.itemForm.quantityAdded != null
                          ? _c(
                              "b-col",
                              { attrs: { md: "5" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required mt-1",
                                  attrs: {
                                    id: "event_product_sidebar-quantityAdded",
                                    type: "number",
                                    label: _vm.$t("Quantidade a adicionar"),
                                    instruction: _vm.quantityAddedInstruction,
                                    validation: _vm.quantityAddedValidation,
                                  },
                                  model: {
                                    value: _vm.itemForm.quantityAdded,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.itemForm,
                                        "quantityAdded",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "itemForm.quantityAdded",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.itemForm.quantityRemoved != null
                          ? _c(
                              "b-col",
                              { attrs: { md: "5" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required mt-1",
                                  attrs: {
                                    id: "event_product_sidebar-quantityRemoved",
                                    type: "number",
                                    label: _vm.$t(
                                      "Quantidade a devolver ao estoque da loja"
                                    ),
                                    instruction: _vm.$t(
                                      "Devolve parte da reserva do evento para o estoque disponível da loja"
                                    ),
                                    validation:
                                      "required|min:1|max:" +
                                      _vm.itemForm.quantity,
                                  },
                                  model: {
                                    value: _vm.itemForm.quantityRemoved,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.itemForm,
                                        "quantityRemoved",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "itemForm.quantityRemoved",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "b-row",
                  { staticClass: "mt-1" },
                  [
                    _c("b-col", [
                      _c("div", [
                        _c("p", { staticClass: "h6 mb-0" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("Quant. em estoque")) + " "
                          ),
                        ]),
                        _c(
                          "p",
                          {
                            staticClass: "h4 text-bold",
                            class: { "text-danger": _vm.infoValues.stock < 0 },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.infoValues.stock === 0
                                    ? 0
                                    : _vm.infoValues.stock || "-"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }